(() => {
  "use strict";

  class AmbrFeatureStrip {
    constructor(section) {
      this.section = section;
      this.slider = section.querySelector(".ambr-feature-slider");

      if (!this.slider) return;

      this.cards = [...this.slider.children];

      this.mobile = window.matchMedia("(max-width:749px)");

      this.current = 0;

      this.init();
    }

    init() {

      this.equalHeight();

      this.bindEvents();

      if (this.mobile.matches) {
        this.enableSnap();
      }

    }

    bindEvents() {

      window.addEventListener("resize", () => {

        this.equalHeight();

      });

      this.mobile.addEventListener("change", () => {

        this.equalHeight();

      });

      this.slider.addEventListener("scroll", () => {

        if (!this.mobile.matches) return;

        clearTimeout(this.scrollTimer);

        this.scrollTimer = setTimeout(() => {

          this.snapToNearest();

        }, 80);

      }, {
        passive: true
      });

    }

    equalHeight() {

      let max = 0;

      this.cards.forEach(card => {

        card.style.minHeight = "";

      });

      if (this.mobile.matches) return;

      this.cards.forEach(card => {

        max = Math.max(max, card.offsetHeight);

      });

      this.cards.forEach(card => {

        card.style.minHeight = max + "px";

      });

    }

    enableSnap() {

      this.slider.style.scrollBehavior = "smooth";

    }

    snapToNearest() {

      const width = this.cards[0].offsetWidth + 18;

      const index = Math.round(this.slider.scrollLeft / width);

      this.slider.scrollTo({

        left: index * width,

        behavior: "smooth"

      });

    }

  }

  document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll(".ambr-feature-strip").forEach(section => {

      new AmbrFeatureStrip(section);

    });

  });

})();